@file:OptIn(InternalResourceApi::class)

package mft_website.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mft_website.composeapp.generated.resources/"

internal val Res.drawable.Foto: DrawableResource by lazy {
      DrawableResource("drawable:Foto", setOf(
        ResourceItem(setOf(), "${MD}drawable/Foto.jpg", -1, -1),
      ))
    }

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.docker: DrawableResource by lazy {
      DrawableResource("drawable:docker", setOf(
        ResourceItem(setOf(), "${MD}drawable/docker.svg", -1, -1),
      ))
    }

internal val Res.drawable.git: DrawableResource by lazy {
      DrawableResource("drawable:git", setOf(
        ResourceItem(setOf(), "${MD}drawable/git.svg", -1, -1),
      ))
    }

internal val Res.drawable.github: DrawableResource by lazy {
      DrawableResource("drawable:github", setOf(
        ResourceItem(setOf(), "${MD}drawable/github.svg", -1, -1),
      ))
    }

internal val Res.drawable.gradle: DrawableResource by lazy {
      DrawableResource("drawable:gradle", setOf(
        ResourceItem(setOf(), "${MD}drawable/gradle.svg", -1, -1),
      ))
    }

internal val Res.drawable.instagram: DrawableResource by lazy {
      DrawableResource("drawable:instagram", setOf(
        ResourceItem(setOf(), "${MD}drawable/instagram.svg", -1, -1),
      ))
    }

internal val Res.drawable.java: DrawableResource by lazy {
      DrawableResource("drawable:java", setOf(
        ResourceItem(setOf(), "${MD}drawable/java.svg", -1, -1),
      ))
    }

internal val Res.drawable.jetpackcompose: DrawableResource by lazy {
      DrawableResource("drawable:jetpackcompose", setOf(
        ResourceItem(setOf(), "${MD}drawable/jetpackcompose.svg", -1, -1),
      ))
    }

internal val Res.drawable.kafka: DrawableResource by lazy {
      DrawableResource("drawable:kafka", setOf(
        ResourceItem(setOf(), "${MD}drawable/kafka.svg", -1, -1),
      ))
    }

internal val Res.drawable.kotlin: DrawableResource by lazy {
      DrawableResource("drawable:kotlin", setOf(
        ResourceItem(setOf(), "${MD}drawable/kotlin.svg", -1, -1),
      ))
    }

internal val Res.drawable.ktor: DrawableResource by lazy {
      DrawableResource("drawable:ktor", setOf(
        ResourceItem(setOf(), "${MD}drawable/ktor.svg", -1, -1),
      ))
    }

internal val Res.drawable.linkedin: DrawableResource by lazy {
      DrawableResource("drawable:linkedin", setOf(
        ResourceItem(setOf(), "${MD}drawable/linkedin.svg", -1, -1),
      ))
    }

internal val Res.drawable.maven: DrawableResource by lazy {
      DrawableResource("drawable:maven", setOf(
        ResourceItem(setOf(), "${MD}drawable/maven.svg", -1, -1),
      ))
    }

internal val Res.drawable.mongodb: DrawableResource by lazy {
      DrawableResource("drawable:mongodb", setOf(
        ResourceItem(setOf(), "${MD}drawable/mongodb.svg", -1, -1),
      ))
    }

internal val Res.drawable.mysql: DrawableResource by lazy {
      DrawableResource("drawable:mysql", setOf(
        ResourceItem(setOf(), "${MD}drawable/mysql.svg", -1, -1),
      ))
    }

internal val Res.drawable.postgres: DrawableResource by lazy {
      DrawableResource("drawable:postgres", setOf(
        ResourceItem(setOf(), "${MD}drawable/postgres.svg", -1, -1),
      ))
    }

internal val Res.drawable.spring: DrawableResource by lazy {
      DrawableResource("drawable:spring", setOf(
        ResourceItem(setOf(), "${MD}drawable/spring.svg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectWebMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("Foto", Res.drawable.Foto)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("docker", Res.drawable.docker)
  map.put("git", Res.drawable.git)
  map.put("github", Res.drawable.github)
  map.put("gradle", Res.drawable.gradle)
  map.put("instagram", Res.drawable.instagram)
  map.put("java", Res.drawable.java)
  map.put("jetpackcompose", Res.drawable.jetpackcompose)
  map.put("kafka", Res.drawable.kafka)
  map.put("kotlin", Res.drawable.kotlin)
  map.put("ktor", Res.drawable.ktor)
  map.put("linkedin", Res.drawable.linkedin)
  map.put("maven", Res.drawable.maven)
  map.put("mongodb", Res.drawable.mongodb)
  map.put("mysql", Res.drawable.mysql)
  map.put("postgres", Res.drawable.postgres)
  map.put("spring", Res.drawable.spring)
}
